import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft, Minus, Plus, Trash2, Lock, Gift, Check, PackageOpen, Loader2, Heart, Sparkles, ShoppingBag, Star } from "lucide-react";
import { auth } from "../../firebase";
import { AppDispatch, RootState } from "../../redux/store";
import { clearCart, removeFromCart, setItemQty } from "../../redux/cartSlice";
import { listenToPublishedProducts } from "../../redux/productSlice";

//const CHECKOUT_URL = process.env.REACT_APP_CHECKOUT_URL || "https://beautables.app/api/Checkout";

const CHECKOUT_URL = process.env.REACT_APP_CHECKOUT_URL || "https://europe-west1-beautables.cloudfunctions.net/createCheckoutSession";

/* the Beautables heart-B logo, embedded (small PNG) so there is no asset path to configure */
const LOGO = "data:image/png;base64,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";

/* ═══════════════ what the shop sends, and what the cart store holds, in one shape ═══════════════ */
type Line = {
  key: string; productId: string; ownerId: string; name: string;
  price: number; qty: number; photo: string; color?: string; size?: string;
};
const lineKey = (i: any) => `${i.productId}|${i.color ?? ""}|${i.size ?? ""}`;
const toLines = (raw: any[]): Line[] =>
  (raw || []).map((i) => ({
    key: lineKey(i),
    productId: String(i.productId ?? i.listingId ?? ""),
    ownerId: String(i.ownerId ?? ""),
    name: i.name ?? "",
    price: Number(i.price ?? i.rate) || 0,
    qty: Math.max(1, Number(i.quantity ?? i.qty) || 1),
    photo: i.photo ?? "",
    color: i.color || undefined,
    size: i.size || undefined,
  }));

type Gift = {
  firstName: string; lastName: string; email: string; phone: string;
  address: string; city: string; state: string; postalCode: string; country: string;
};
const emptyGift = (): Gift => ({ firstName: "", lastName: "", email: "", phone: "", address: "", city: "", state: "", postalCode: "", country: "" });

const money = (v: number) => `€${(Number(v) || 0).toFixed(2)}`;

/* ═══════════════ STYLES: shop palette (black, white, yellow, raspberry, lime, pink), turned up to cute ═══════════════ */
const INK = "#000";
const RED_DARK = "#B30000";
const BODY = "#5C5C5C";
const LINE = "#F3D3E4";
const YEL = "#FFD60A";
const YEL_HI = "#FFF27A";
const YEL_LO = "#F2B800";
const YEL_SOFT = "#FFF8CC";
const RASP = "#E30B5C";
const LIME = "#C8E17A";
const PINK = "#FF6BB5";
const PINK_SOFT = "#FFF0F7";
const PINK_MID = "#FFD0E6";
const YEL_GLOSS = `linear-gradient(180deg, ${YEL_HI} 0%, ${YEL} 52%, ${YEL_LO} 100%)`;
const RASP_GLOSS = `linear-gradient(180deg, #FF5C95 0%, ${RASP} 52%, #B80848 100%)`;
const LIME_GLOSS = `linear-gradient(180deg, #E6F5B4 0%, ${LIME} 52%, #A9C95A 100%)`;

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@500;600;700&family=Jost:wght@300;400;500;600&display=swap');
.ck-page, .ck-page *, .ck-page *::before, .ck-page *::after{ box-sizing:border-box; font-family:'Jost',system-ui,sans-serif; }
.ck-root{ min-height:100vh; width:100%; max-width:100vw; display:flex; flex-direction:column; overflow-x:hidden; background:${PINK_SOFT}; }
.ck-page{ position:relative; flex:1; width:100%; max-width:100vw; color:${INK}; overflow-x:hidden;
  background-color:${PINK_SOFT};
  background-image:radial-gradient(${PINK_MID} 2.2px, transparent 2.4px), radial-gradient(${YEL_SOFT} 2.2px, transparent 2.4px);
  background-size:26px 26px, 26px 26px; background-position:0 0, 13px 13px;
  padding:24px 16px 64px; padding-top:calc(24px + env(safe-area-inset-top)); }
.ck-page button{ font-family:inherit; cursor:pointer; border:none; background:none; color:inherit; padding:0; }
.ck-page button:disabled{ cursor:not-allowed; opacity:.5; }
.ck-page button:focus-visible, .ck-page input:focus-visible{ outline:3px solid ${INK}; outline-offset:3px; }
.ck-wrap{ position:relative; z-index:1; width:100%; max-width:640px; min-width:0; margin:0 auto; }
.ck-page h2{ font-family:'Cormorant Garamond',serif; font-size:clamp(42px,8vw,58px); font-weight:700; line-height:1; margin:14px 0 6px; display:flex; align-items:center; gap:10px; flex-wrap:wrap; }
.ck-page h3{ font-family:'Cormorant Garamond',serif; font-size:30px; font-weight:700; margin:0; }
.ck-page p{ margin:0; }
.ck-muted{ color:${BODY}; }
.ck-small{ font-size:13px; }
.ck-sub{ display:flex; align-items:center; gap:7px; margin:0 0 22px; font-size:12px; font-weight:500; letter-spacing:.2em; text-transform:uppercase; color:${RASP}; }

/* top bar with the logo */
.ck-top{ display:flex; align-items:center; justify-content:space-between; gap:12px; }
.ck-logo{ width:60px; height:auto; display:block; filter:drop-shadow(0 4px 0 rgba(0,0,0,.9)); animation:ckBob 3.2s ease-in-out infinite; cursor:pointer; transition:transform .3s cubic-bezier(.2,.9,.3,1.5); }
.ck-logo:hover{ transform:rotate(-8deg) scale(1.1); animation:none; }

/* floating flowers (from the logo) */
.ck-fl{ position:absolute; z-index:0; pointer-events:none; opacity:.95; animation:ckFloat 5s ease-in-out infinite; }
.ck-fl.a{ top:90px; left:5%; }
.ck-fl.b{ top:190px; right:6%; animation-delay:-1.4s; }
.ck-fl.c{ top:46%; left:3%; animation-delay:-2.6s; }
.ck-fl.d{ top:62%; right:4%; animation-delay:-3.4s; }
@media (max-width:760px){ .ck-fl{ display:none; } }
@keyframes ckFloat{ 0%,100%{ transform:translateY(0) rotate(-8deg); } 50%{ transform:translateY(-14px) rotate(14deg); } }

.ck-back{ display:inline-flex; align-items:center; gap:8px; height:40px; padding:0 18px 0 12px; border-radius:999px; border:2px solid ${INK};
  background:linear-gradient(180deg,#fff,#f4f4f4); box-shadow:inset 0 2px 1px #fff, 0 4px 0 ${INK};
  font-size:11.5px; font-weight:600; letter-spacing:.18em; text-transform:uppercase; transition:all .2s; }
.ck-back:hover{ background:${YEL_GLOSS}; transform:translateY(-2px); box-shadow:inset 0 2px 1px rgba(255,255,255,.9), 0 6px 0 ${INK}; }
.ck-back:active{ transform:translateY(3px); box-shadow:0 1px 0 ${INK}; }

/* sticker cards */
.ck-card{ position:relative; min-width:0; background:#fff; border:2.5px solid ${INK}; border-radius:30px; padding:22px 20px; margin-bottom:22px;
  box-shadow:inset 0 3px 0 #fff, 0 7px 0 ${INK}, 0 20px 26px -14px rgba(0,0,0,.4); }
.ck-card::after{ content:""; position:absolute; inset:6px; border:2px dashed ${PINK_MID}; border-radius:24px; pointer-events:none; }
.ck-card > *{ position:relative; z-index:1; }
.ck-card-head{ display:flex; align-items:center; gap:10px; margin:-2px 0 14px; }
.ck-step{ width:34px; height:34px; border-radius:50%; flex:none; display:flex; align-items:center; justify-content:center; font-size:15px; font-weight:600; color:#fff;
  background:radial-gradient(circle at 30% 24%, #fff 0, rgba(255,255,255,.85) 6%, rgba(255,255,255,0) 26%), radial-gradient(circle at 36% 30%, #ff8cc4 0, ${PINK} 48%, #d63f8c 100%);
  box-shadow:inset -3px -4px 7px rgba(0,0,0,.25), inset 1px 1px 3px rgba(255,255,255,.6), 0 0 0 2px ${INK}, 0 4px 0 ${INK}; }
.ck-step.y{ color:${INK}; background:radial-gradient(circle at 30% 24%, #fff 0, rgba(255,255,255,.85) 6%, rgba(255,255,255,0) 26%), radial-gradient(circle at 36% 30%, ${YEL_HI} 0, ${YEL} 48%, ${YEL_LO} 100%); }
.ck-step.l{ color:${INK}; background:radial-gradient(circle at 30% 24%, #fff 0, rgba(255,255,255,.85) 6%, rgba(255,255,255,0) 26%), radial-gradient(circle at 36% 30%, #eaf8bd 0, ${LIME} 48%, #9bbd4f 100%); }
.ck-card-title{ font-family:'Cormorant Garamond',serif; font-size:26px; font-weight:700; line-height:1; }
.ck-clear{ margin-left:auto; display:inline-flex; align-items:center; gap:6px; height:32px; padding:0 12px; border-radius:999px; border:2px solid ${INK}; background:#fff; box-shadow:0 3px 0 ${INK};
  font-size:10.5px; font-weight:600; letter-spacing:.14em; text-transform:uppercase; transition:all .2s; }
.ck-clear:hover{ background:${RASP_GLOSS}; color:#fff; transform:translateY(-1px); }
.ck-clear:active{ transform:translateY(3px); box-shadow:0 0 0 ${INK}; }

/* lines */
.ck-line{ display:flex; align-items:center; gap:14px; padding:14px 0; border-bottom:2px dotted ${LINE}; min-width:0; }
.ck-line:last-child{ border-bottom:none; padding-bottom:4px; }
.ck-thumb{ width:72px; height:90px; border-radius:20px; overflow:hidden; background:${YEL_SOFT}; border:2px solid ${INK}; box-shadow:0 4px 0 ${INK}; flex-shrink:0; display:flex; align-items:center; justify-content:center; color:#6B6B6B; cursor:zoom-in;
  transition:transform .3s cubic-bezier(.2,.9,.3,1.5); }
.ck-thumb:hover{ transform:rotate(-4deg) scale(1.08); }
.ck-thumb img{ width:100%; height:100%; object-fit:cover; display:block; }
.ck-grow{ flex:1; min-width:0; }
.ck-name{ display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; word-break:break-word; font-family:'Cormorant Garamond',serif; font-size:23px; font-weight:700; line-height:1.15; }
.ck-opts{ display:flex; flex-wrap:wrap; gap:6px; margin-top:6px; }
.ck-opt{ font-size:10px; font-weight:600; letter-spacing:.14em; text-transform:uppercase; padding:4px 11px; border-radius:999px; border:1.5px solid ${INK}; background:${YEL_SOFT}; box-shadow:0 2px 0 ${INK}; max-width:100%; overflow-wrap:anywhere; }
.ck-opt:nth-child(2){ background:#EEF8D2; }
.ck-each{ font-size:13px; color:${BODY}; margin-top:7px; }
.ck-right{ display:flex; flex-direction:column; align-items:flex-end; gap:8px; flex-shrink:0; }
.ck-lt{ display:inline-flex; padding:3px 12px; border-radius:999px; background:linear-gradient(180deg,#fff,#ececec); border:1.5px solid ${INK}; box-shadow:0 3px 0 ${INK}; font-size:15px; font-weight:600; white-space:nowrap; }
.ck-qty{ display:inline-flex; align-items:center; height:38px; padding:0 3px; border:2px solid ${INK}; border-radius:999px; background:#fff; box-shadow:0 3px 0 ${INK}; }
.ck-qty button{ width:30px; height:30px; border-radius:50%; display:flex; align-items:center; justify-content:center; transition:background .2s, transform .2s; }
.ck-qty button:hover:not(:disabled){ background:${LIME_GLOSS}; transform:scale(1.12); }
.ck-qty b{ min-width:26px; text-align:center; font-size:15px; font-weight:600; }
.ck-x{ width:32px; height:32px; border-radius:50%; border:2px solid ${INK}; background:#fff; display:flex; align-items:center; justify-content:center; box-shadow:0 3px 0 ${INK}; transition:all .2s; }
.ck-x:hover{ background:${RASP_GLOSS}; color:#fff; transform:rotate(-12deg) scale(1.1); }

/* gift switch */
.ck-gift{ display:flex; align-items:center; gap:14px; width:100%; text-align:left; padding:14px 16px; border-radius:22px; border:2px solid ${INK}; background:linear-gradient(180deg,#fff,#f6f6f6); box-shadow:0 4px 0 ${INK}; transition:all .2s; }
.ck-gift:hover{ background:${YEL_SOFT}; transform:translateY(-2px); box-shadow:0 6px 0 ${INK}; }
.ck-gift.on{ background:${PINK_SOFT}; }
.ck-gtext{ min-width:0; flex:1; }
.ck-orb{ position:relative; width:44px; height:44px; border-radius:50%; flex-shrink:0; display:flex; align-items:center; justify-content:center; color:#fff;
  background:radial-gradient(circle at 30% 24%, #fff 0, rgba(255,255,255,.85) 6%, rgba(255,255,255,0) 26%), radial-gradient(circle at 36% 30%, #ff6fa3 0, ${RASP} 48%, #8F0636 100%);
  box-shadow:inset -3px -4px 7px rgba(0,0,0,.32), inset 1px 1px 3px rgba(255,255,255,.6), 0 0 0 2px ${INK}, 0 5px 0 ${INK}; }
.ck-gift:hover .ck-orb{ animation:ckWiggle .6s ease-in-out; }
.ck-gtext b{ display:block; font-size:12px; font-weight:600; letter-spacing:.18em; text-transform:uppercase; }
.ck-gtext span.sub{ display:block; font-size:13px; color:${BODY}; margin-top:2px; }
.ck-knob{ position:relative; width:52px; height:30px; border-radius:999px; background:#E2E2E2; border:2px solid ${INK}; flex-shrink:0; margin-left:auto; transition:background .2s; }
.ck-knob::after{ content:""; position:absolute; top:2px; left:2px; width:22px; height:22px; border-radius:50%; background:#fff; border:2px solid ${INK}; transition:transform .25s cubic-bezier(.2,.9,.3,1.5); }
.ck-gift.on .ck-knob{ background:${PINK}; }
.ck-gift.on .ck-knob::after{ transform:translateX(22px); }

.ck-form{ display:grid; grid-template-columns:minmax(0,1fr) minmax(0,1fr); gap:0 14px; margin-top:6px; animation:ckDrop .3s cubic-bezier(.2,.9,.3,1.2); }
.ck-form > *{ min-width:0; }
.ck-form .full{ grid-column:1 / -1; }
@media (max-width:520px){ .ck-form{ grid-template-columns:minmax(0,1fr); } }
.ck-label{ display:block; font-size:11px; font-weight:600; letter-spacing:.16em; text-transform:uppercase; margin:16px 0 8px; }
.ck-label i{ color:${RASP}; font-style:normal; margin-left:4px; }
.ck-input{ display:block; width:100%; max-width:100%; height:48px; padding:0 18px; border-radius:999px; border:2px solid ${INK}; background:#fff; font-size:16px; color:${INK}; outline:none; box-shadow:inset 0 2px 4px rgba(0,0,0,.06), 0 3px 0 ${INK}; transition:all .2s; }
.ck-input::placeholder{ color:#B5A3AD; }
.ck-input:hover{ background:${YEL_SOFT}; }
.ck-input:focus{ background:${YEL_SOFT}; box-shadow:inset 0 2px 4px rgba(0,0,0,.06), 0 0 0 4px ${YEL}, 0 0 0 6px ${INK}; }
.ck-input.bad{ border-color:${RASP}; background:#FFE9F1; box-shadow:inset 0 2px 4px rgba(0,0,0,.06), 0 3px 0 ${RASP}; animation:ckShake .35s; }

/* totals */
.ck-row{ display:flex; align-items:baseline; justify-content:space-between; padding:6px 0; font-size:14px; }
.ck-total{ display:flex; align-items:center; justify-content:space-between; gap:10px; margin-top:12px; padding:12px 18px; border-radius:999px; background:${PINK_SOFT}; border:2px dashed ${PINK}; }
.ck-total small{ font-size:11px; font-weight:600; letter-spacing:.22em; text-transform:uppercase; color:${RASP}; }
.ck-total b{ font-family:'Cormorant Garamond',serif; font-size:38px; font-weight:700; line-height:1; }
.ck-error{ margin-top:14px; padding:10px 16px; border-radius:18px; border:2px solid ${INK}; background:#FFE9F1; box-shadow:0 3px 0 ${RASP}; font-size:13px; font-weight:500; color:${RED_DARK}; animation:ckShake .35s; }
.ck-note{ display:flex; align-items:center; gap:8px; margin:0 0 20px; padding:12px 18px; border-radius:999px; border:2px solid ${INK}; background:${YEL_SOFT}; box-shadow:0 4px 0 ${INK}; font-size:12px; font-weight:600; letter-spacing:.1em; text-transform:uppercase; }

/* glossy 3D button, same as the shop (".ck-page .ck-btn" so the generic button reset never wins) */
.ck-page .ck-btn{ position:relative; isolation:isolate; overflow:hidden; display:inline-flex; align-items:center; justify-content:center; gap:8px; height:54px; padding:0 30px; border-radius:999px;
  background:linear-gradient(180deg,#4a4a4a 0%,#111 48%,#000 100%); border:1px solid #000; color:#fff !important;
  font-size:11.5px; font-weight:600; letter-spacing:.22em; text-transform:uppercase; text-shadow:0 1px 2px rgba(0,0,0,.5);
  box-shadow:inset 0 2px 2px rgba(255,255,255,.4), inset 0 -4px 6px rgba(0,0,0,.55), 0 5px 0 #2b2b2b, 0 12px 18px -6px rgba(0,0,0,.55);
  transition:background .25s, transform .15s, box-shadow .15s; }
.ck-btn::before{ content:""; position:absolute; z-index:-1; left:7%; right:7%; top:3px; height:46%; border-radius:999px; background:linear-gradient(180deg,rgba(255,255,255,.55),rgba(255,255,255,.05)); pointer-events:none; }
.ck-btn::after{ content:""; position:absolute; z-index:0; inset:0; pointer-events:none; transform:translateX(-130%); transition:transform .6s ease;
  background:linear-gradient(115deg, rgba(255,255,255,0) 35%, rgba(255,255,255,.5) 48%, rgba(255,255,255,0) 61%); }
.ck-btn:hover:not(:disabled)::after{ transform:translateX(130%); }
.ck-page .ck-btn:hover:not(:disabled){ background:${RASP_GLOSS}; border-color:#8F0636; transform:translateY(-2px);
  box-shadow:inset 0 2px 2px rgba(255,255,255,.6), inset 0 -4px 6px rgba(0,0,0,.25), 0 7px 0 #8F0636, 0 16px 22px -6px rgba(227,11,92,.5); }
.ck-page .ck-btn:active:not(:disabled){ transform:translateY(4px); box-shadow:inset 0 2px 2px rgba(255,255,255,.4), inset 0 -3px 5px rgba(0,0,0,.3), 0 1px 0 #8F0636, 0 4px 8px -4px rgba(0,0,0,.5); }
.ck-btn.block{ width:100%; margin-top:20px; height:58px; }

.ck-cap{ font-size:10px; font-weight:600; letter-spacing:.14em; text-transform:uppercase; color:${RASP}; }
.ck-trust{ display:flex; align-items:center; justify-content:center; gap:8px; margin-top:14px; text-align:center; }

/* hover peek (desktop) */
.ck-hov{ position:fixed; z-index:600; width:312px; background:#fff; border:2.5px solid ${INK}; border-radius:26px; padding:14px 16px 12px; pointer-events:none;
  box-shadow:0 6px 0 ${INK}, 0 24px 50px -20px rgba(0,0,0,.45); animation:ckDrop .18s ease-out; }
.ck-hov h4{ margin:0 0 6px; font-family:'Cormorant Garamond',serif; font-size:23px; font-weight:700; line-height:1.15; }
.ck-hrow{ display:flex; align-items:center; gap:10px; padding:8px 0; border-top:2px dotted ${LINE}; }
.ck-hph{ width:44px; height:56px; border-radius:12px; overflow:hidden; background:${YEL_SOFT}; border:2px solid ${INK}; flex-shrink:0; display:flex; align-items:center; justify-content:center; }
.ck-hph img{ width:100%; height:100%; object-fit:cover; display:block; }
.ck-hcol{ display:flex; align-items:center; gap:6px; font-size:12px; font-weight:600; letter-spacing:.1em; text-transform:uppercase; }
.ck-hdot{ width:15px; height:15px; border-radius:50%; border:1.5px solid ${INK}; flex-shrink:0; }
.ck-hfoot{ display:flex; align-items:baseline; justify-content:space-between; margin-top:4px; padding-top:10px; border-top:2px solid ${INK}; font-size:12px; letter-spacing:.14em; text-transform:uppercase; }
.ck-hfoot b{ font-family:'Cormorant Garamond',serif; font-size:26px; font-weight:700; letter-spacing:0; }
@media (max-width:768px){ .ck-hov{ display:none; } }

/* items that are gone */
.ck-gonehead{ display:flex; align-items:center; gap:10px; margin:-2px 0 14px; }
.ck-gonegrid{ display:grid; grid-template-columns:repeat(auto-fill,minmax(min(100%,150px),1fr)); gap:14px; }
.ck-gcard{ min-width:0; border:2px solid ${INK}; border-radius:22px; overflow:hidden; background:#fff; box-shadow:0 4px 0 ${INK}; }
.ck-gimg{ position:relative; aspect-ratio:4/5; background:${YEL_SOFT}; display:flex; align-items:center; justify-content:center; color:#6B6B6B; }
.ck-gimg img{ width:100%; height:100%; object-fit:cover; display:block; filter:grayscale(1); opacity:.55; }
.ck-gtag{ position:absolute; left:8px; bottom:8px; padding:4px 11px; border-radius:999px; background:${RASP_GLOSS}; color:#fff; border:1.5px solid ${INK}; box-shadow:0 2px 0 ${INK}; font-size:10px; font-weight:600; letter-spacing:.12em; text-transform:uppercase; }
.ck-ginfo{ padding:10px 12px 12px; border-top:2px solid ${INK}; min-width:0; }
.ck-ginfo b{ display:block; font-family:'Cormorant Garamond',serif; font-size:19px; font-weight:700; line-height:1.1; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.ck-ginfo span{ display:block; margin-top:3px; font-size:12px; color:${BODY}; }
.ck-ginfo em{ display:block; margin-top:7px; font-style:normal; font-size:12px; font-weight:500; line-height:1.4; color:${RASP}; }

.ck-empty{ display:flex; flex-direction:column; align-items:center; gap:12px; text-align:center; padding:44px 20px; }
.ck-empty-logo{ width:110px; height:auto; display:block; filter:drop-shadow(0 6px 0 rgba(0,0,0,.9)); animation:ckBob 2.6s ease-in-out infinite; }
.ck-center{ display:flex; align-items:center; justify-content:center; padding:20px; }
.ck-thanks{ text-align:center; max-width:440px; width:100%; padding:38px 24px 30px; }
.ck-thanks .ck-empty-logo{ width:120px; margin:0 auto 18px; }
.ck-thanks h2{ justify-content:center; margin:0; }
.ck-thanks p{ margin:10px 0 24px; }
.ck-thanks .ck-ok{ display:inline-flex; align-items:center; justify-content:center; width:34px; height:34px; border-radius:50%; background:${LIME_GLOSS}; border:2px solid ${INK}; box-shadow:0 3px 0 ${INK}; }
.ck-pop{ position:absolute; z-index:0; pointer-events:none; animation:ckRise 3.6s ease-in infinite; opacity:0; }
.ck-spin{ animation:ckSpin .8s linear infinite; }
@keyframes ckSpin{ to{ transform:rotate(360deg); } }
@keyframes ckDrop{ from{ opacity:0; transform:translateY(-8px) scale(.98); } to{ opacity:1; transform:translateY(0) scale(1); } }
@keyframes ckBob{ 0%,100%{ transform:translateY(0); } 50%{ transform:translateY(-8px); } }
@keyframes ckWiggle{ 0%,100%{ transform:rotate(0); } 25%{ transform:rotate(-14deg); } 75%{ transform:rotate(14deg); } }
@keyframes ckShake{ 0%,100%{ transform:translateX(0); } 25%{ transform:translateX(-5px); } 75%{ transform:translateX(5px); } }
@keyframes ckRise{ 0%{ opacity:0; transform:translateY(40px) scale(.6) rotate(0); } 15%{ opacity:1; } 100%{ opacity:0; transform:translateY(-260px) scale(1.1) rotate(25deg); } }


/* footer: black, with the logo's flowers and the big BEAUTABLES word */
.ck-foot{ position:relative; width:100%; background:#000; color:#fff; overflow:hidden; padding-bottom:env(safe-area-inset-bottom); font-family:'Jost',system-ui,sans-serif; }
.ck-foot *{ box-sizing:border-box; }
.ck-foot-bar{ height:10px; background:repeating-linear-gradient(90deg, ${RASP} 0 24px, ${PINK} 24px 48px, ${YEL} 48px 72px); }
.ck-foot-top{ position:relative; z-index:2; display:flex; align-items:center; justify-content:space-between; gap:12px; flex-wrap:wrap; max-width:1180px; margin:0 auto; padding:22px 20px 0; font-size:14px; font-weight:500; color:rgba(255,255,255,.75); }
.ck-foot-logo{ width:46px; height:auto; display:block; animation:ckBob 3.2s ease-in-out infinite; }
.ck-ff{ position:absolute; z-index:1; pointer-events:none; animation:ckFloat 5.5s ease-in-out infinite; }
.ck-footword{ position:relative; z-index:2; display:block; text-align:center; white-space:nowrap; user-select:none; font-family:'Cormorant Garamond',Georgia,serif; font-weight:700; font-size:clamp(34px,13.2vw,190px); line-height:.82; letter-spacing:-.01em; margin:34px 0 -.06em; padding:0 6px; }
.ck-footword span{ color:${PINK}; }

/* phones: price + qty + delete move to their own row under the name, nothing runs off the right edge */
@media (max-width:560px){
  .ck-page{ padding-left:12px; padding-right:12px; }
  .ck-card{ padding:20px 16px; }
  .ck-line{ flex-wrap:wrap; align-items:flex-start; gap:12px; }
  .ck-thumb{ width:64px; height:82px; }
  .ck-name{ font-size:21px; }
  .ck-right{ flex-direction:row; flex-wrap:wrap; align-items:center; justify-content:space-between; flex-basis:100%; gap:10px; }
  .ck-right .ck-lt{ order:1; }
  .ck-right .ck-cap{ order:2; }
  .ck-right .ck-qty{ order:3; margin-left:auto; }
  .ck-right .ck-x{ order:4; }
  .ck-logo{ width:52px; }
  .ck-total b{ font-size:34px; }
}
@media (prefers-reduced-motion: reduce){ .ck-form, .ck-spin, .ck-fl, .ck-ff, .ck-foot-logo, .ck-pop, .ck-logo, .ck-empty-logo, .ck-input.bad, .ck-error{ animation:none !important; } .ck-page *{ transition:none !important; } }
`;

/* a little flower, lifted from the logo */
const Flower: React.FC<{ size?: number; className?: string; style?: React.CSSProperties }> = ({ size = 28, className, style }) => (
  <svg viewBox="0 0 40 40" width={size} height={size} className={className} style={style} aria-hidden="true">
    <g fill="#FF3D71" stroke="#000" strokeWidth="1.6">
      <circle cx="12" cy="12" r="8.5" /><circle cx="28" cy="12" r="8.5" /><circle cx="12" cy="28" r="8.5" /><circle cx="28" cy="28" r="8.5" />
    </g>
    <circle cx="20" cy="20" r="7" fill="#FFD84A" stroke="#000" strokeWidth="1.6" />
  </svg>
);


/* black footer: the logo, little flowers drifting about, and the big word */
const Footer: React.FC = () => {
  const bloom: { l: string; t: string; s: number; d: string }[] = [
    { l: "4%", t: "22%", s: 40, d: "0s" }, { l: "17%", t: "46%", s: 26, d: "-1.6s" }, { l: "31%", t: "18%", s: 32, d: "-3.1s" },
    { l: "52%", t: "40%", s: 22, d: "-.8s" }, { l: "68%", t: "16%", s: 36, d: "-2.3s" }, { l: "83%", t: "44%", s: 28, d: "-3.9s" }, { l: "93%", t: "20%", s: 38, d: "-1.1s" },
  ];
  return (
    <footer className="ck-foot">
      <div className="ck-foot-bar" />
      <div className="ck-foot-top">
        <img className="ck-foot-logo" src={LOGO} alt="" />
        <span>© {new Date().getFullYear()} Beautables</span>
      </div>
      {bloom.map((f, i) => <Flower key={i} className="ck-ff" size={f.s} style={{ left: f.l, top: f.t, animationDelay: f.d }} />)}
      <b className="ck-footword" aria-label="Beautables">BEAUTABLES<span>.</span></b>
    </footer>
  );
};

/* ═══════════════ PAGE ═══════════════ */
export default function Checkout() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const location = useLocation();
  const [params] = useSearchParams();
  const storeItems = useSelector((s: RootState) => (s as any).cart?.items ?? []);

  /* what the shop handed over; the cart store is only the fallback */
  const fromShop: any[] | undefined = (location.state as any)?.items;
  const [lines, setLines] = useState<Line[]>(() => toLines(fromShop ?? storeItems));
  useEffect(() => { if (!fromShop) setLines(toLines(storeItems)); }, [fromShop, storeItems]);

  const [gifting, setGifting] = useState(false);
  const [gift, setGift] = useState<Gift>(emptyGift());
  const [tried, setTried] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [gone, setGone] = useState<any[]>([]);
  const paid = params.get("paid") === "1";

  useEffect(() => { if (paid) dispatch(clearCart()); }, [paid, dispatch]);

  const total = useMemo(() => lines.reduce((s, l) => s + l.price * l.qty, 0), [lines]);
  const count = useMemo(() => lines.reduce((s, l) => s + l.qty, 0), [lines]);

  const products = useSelector((s: any) => s.products?.products) as any[] | undefined;
  useEffect(() => {
    const unsub = dispatch(listenToPublishedProducts() as any) as any;
    return () => { if (typeof unsub === "function") unsub(); };
  }, [dispatch]);

  const [hov, setHov] = useState<{ productId: string; x: number; y: number } | null>(null);
  const productOf = (id: string) => (products ?? []).find((p) => p.productId === id);

  /* how many of this line can still be bought, from the live product data (Infinity = unknown, the server decides) */
  const availOf = (l: Line, list: Line[]): number => {
    const p = productOf(l.productId);
    if (!p) return Infinity;
    const vs: any[] = (p.variants || []).filter((v: any) => v && v.color);
    const v = l.color ? vs.find((x) => x.color === l.color) : undefined;
    let own = Infinity;
    if (v) {
      const rows: any[] = v.stock || [];
      if (rows.length) {
        own = l.size
          ? Number(rows.find((s) => s.size === l.size)?.qty) || 0
          : rows.reduce((s, x) => s + (Number(x.qty) || 0), 0);
      }
    }
    const all = p.quantity == null ? Infinity : Math.max(0, Number(p.quantity) || 0);
    const others = list.filter((x) => x.productId === l.productId && x.key !== l.key).reduce((s, x) => s + x.qty, 0);
    return Math.min(own, all - others);
  };
  const maxFor = (l: Line): number => Math.max(1, availOf(l, lines));

  /* live stock watch: a piece that sells out while it sits in the bag is removed, a shrinking stock lowers the quantity,
     both mirrored into the cart store and shown under "No longer available" */
  useEffect(() => {
    if (!products || !lines.length) return;
    let next = lines;
    const found: any[] = [];
    lines.forEach((l) => {
      const cur = next.find((x) => x.key === l.key);
      if (!cur) return;
      const a = availOf(cur, next);
      if (a === Infinity || a >= cur.qty) return;
      const left = Math.max(0, a);
      found.push({ id: `${cur.key}|live|${Date.now()}|${found.length}`, name: cur.name || "Item", photo: cur.photo, color: cur.color, size: cur.size, wanted: cur.qty, left, reason: left > 0 ? "low" : "out-of-stock" });
      if (left > 0) {
        next = next.map((x) => (x.key === cur.key ? { ...x, qty: left } : x));
        dispatch(setItemQty({ productId: cur.productId, color: cur.color, size: cur.size, qty: left }));
      } else {
        next = next.filter((x) => x.key !== cur.key);
        dispatch(removeFromCart({ productId: cur.productId, color: cur.color, size: cur.size }));
      }
    });
    if (found.length) {
      setLines(next);
      setGone((g) => [...found, ...g]);
      setHov(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products, lines]);

  /* every change here is mirrored into the cart store, so the shop shows the same bag */
  const bump = (key: string, d: number) => {
    const l = lines.find((x) => x.key === key);
    if (!l) return;
    const qty = Math.min(Math.max(1, l.qty + d), maxFor(l));
    setLines((ls) => ls.map((x) => (x.key === key ? { ...x, qty } : x)));
    dispatch(setItemQty({ productId: l.productId, color: l.color, size: l.size, qty }));
  };
  const drop = (key: string) => {
    const l = lines.find((x) => x.key === key);
    setLines((ls) => ls.filter((x) => x.key !== key));
    setHov(null);
    if (l) dispatch(removeFromCart({ productId: l.productId, color: l.color, size: l.size }));
  };
  const clearAll = () => {
    setLines([]);
    setHov(null);
    dispatch(clearCart());
  };
  const setG = (k: keyof Gift, v: string) => setGift((g) => ({ ...g, [k]: v }));

  /* only the "someone else" form is ever required */
  const giftMissing = {
    firstName: !gift.firstName.trim(), email: !gift.email.trim(), address: !gift.address.trim(),
    city: !gift.city.trim(), country: !gift.country.trim(),
  };
  const giftOk = !Object.values(giftMissing).some(Boolean);

  const pay = async () => {
    setTried(true);
    setError("");
    if (gifting && !giftOk) { setError("Fill in the highlighted details for the person you are buying for."); return; }
    setBusy(true);
    try {
      const u = auth.currentUser;
      if (!u) throw new Error("Please log in first.");
      const idToken = await u.getIdToken();
      const res = await fetch(CHECKOUT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${idToken}` },
        body: JSON.stringify({
          /* "productId:ownerId:n:qty", the server re-prices everything from Firestore */
          itemRefs: lines.map((l, n) => `${l.productId}:${l.ownerId}:${n}:${l.qty}`),
          /* the same lines with the buyer's color and size choice */
          items: lines.map((l) => ({
            productId: l.productId, ownerId: l.ownerId, name: l.name, qty: l.qty,
            ...(l.color ? { color: l.color } : {}),
            ...(l.size ? { size: l.size } : {}),
          })),
          buyerUserId: u.uid,
          /* null = it is for the signed-in buyer; Stripe collects their address */
          giftRecipient: gifting
            ? {
                firstName: gift.firstName.trim(), lastName: gift.lastName.trim(), email: gift.email.trim().toLowerCase(), phone: gift.phone.trim(),
                shippingAddress: {
                  streetAddress: gift.address.trim(), city: gift.city.trim(), state: gift.state.trim(),
                  zipCode: gift.postalCode.trim(), country: gift.country.trim(),
                },
              }
            : null,
          returnUrl: window.location.origin,
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.url) {
        /* the server says what is no longer available: lower or remove those lines, keep the cart store in step, show them below */
        const un = data?.error?.unavailable;
        if (Array.isArray(un) && un.length) {
          const found: any[] = [];
          let next = lines;
          un.forEach((x: any) => {
            const m = next.filter((l) => l.productId === String(x.productId) && (x.color == null || l.color === x.color) && (x.size == null || l.size === x.size));
            const left = Math.max(0, Number(x.available) || 0);
            m.forEach((l) => {
              found.push({ id: `${l.key}|${found.length}`, name: l.name || x.name || "Item", photo: l.photo, color: l.color, size: l.size, wanted: l.qty, left, reason: x.reason });
              if (left > 0 && m.length === 1) {
                next = next.map((y) => (y.key === l.key ? { ...y, qty: left } : y));
                dispatch(setItemQty({ productId: l.productId, color: l.color, size: l.size, qty: left }));
              } else {
                next = next.filter((y) => y.key !== l.key);
                dispatch(removeFromCart({ productId: l.productId, color: l.color, size: l.size }));
              }
            });
          });
          setLines(next);
          setGone((g) => [...found, ...g]);
          throw new Error(next.length ? "Some items changed and your bag was updated. Check the total and pay again." : "These items are no longer available.");
        }
        throw new Error(data?.error?.message || data?.error || "Couldn't start checkout. Try again.");
      }
      window.location.href = data.url; // Stripe Checkout: cards, Apple Pay, Google Pay
    } catch (e: any) {
      setError(e.message);
      setBusy(false);
    }
  };

  /* ── thank you ── */
  if (paid) {
    return (
      <div className="ck-root">
        <style>{CSS}</style>
        <div className="ck-page ck-center">
        <Flower className="ck-pop" size={30} style={{ left: "22%", bottom: "18%", animationDelay: "0s" }} />
        <Star className="ck-pop" size={22} fill={YEL} color={INK} style={{ left: "70%", bottom: "14%", animationDelay: "1.1s" }} />
        <Heart className="ck-pop" size={22} fill={RASP} color={INK} style={{ left: "42%", bottom: "10%", animationDelay: "2.2s" }} />
        <Flower className="ck-pop" size={26} style={{ left: "82%", bottom: "26%", animationDelay: "1.7s" }} />
        <div className="ck-card ck-thanks">
          <img className="ck-empty-logo" src={LOGO} alt="Beautables" />
          <h2>Thank you! <span className="ck-ok"><Check size={20} strokeWidth={3.2} /></span></h2>
          <p className="ck-muted">Your order is confirmed and we are wrapping it up with love.</p>
          <button className="ck-btn" onClick={() => navigate("/orders")}><Sparkles size={15} /> See my orders</button>
        </div>
        </div>
        <Footer />
      </div>
    );
  }

  const field = (k: keyof Gift, label: string, opts: { req?: boolean; full?: boolean; type?: string; ph?: string } = {}) => (
    <div className={opts.full ? "full" : ""}>
      <label className="ck-label">{label}{opts.req && <i>*</i>}</label>
      <input
        className={`ck-input${tried && opts.req && (giftMissing as any)[k] ? " bad" : ""}`}
        type={opts.type || "text"} placeholder={opts.ph} value={gift[k]} onChange={(e) => setG(k, e.target.value)}
      />
    </div>
  );

  return (
    <div className="ck-root">
      <style>{CSS}</style>
      <div className="ck-page">
      <Flower className="ck-fl a" size={38} />
      <Star className="ck-fl b" size={28} fill={YEL} color={INK} />
      <Flower className="ck-fl c" size={32} />
      <Heart className="ck-fl d" size={28} fill={PINK} color={INK} />
      <div className="ck-wrap">
        <div className="ck-top">
          <button className="ck-back" onClick={() => navigate("/")}><ArrowLeft size={16} /> Keep shopping</button>
          <img className="ck-logo" src={LOGO} alt="Beautables" onClick={() => navigate("/")} />
        </div>
        <h2>Checkout <Flower size={34} /></h2>
        <p className="ck-sub"><Heart size={14} fill={RASP} /> Almost yours</p>

        {params.get("cancelled") === "1" && <p className="ck-note"><Heart size={15} fill={PINK} /> Payment cancelled. Your bag is safe.</p>}

        {lines.length === 0 ? (
          <div className="ck-card ck-empty">
            <img className="ck-empty-logo" src={LOGO} alt="" />
            <h3>Your bag is empty</h3>
            <p className="ck-muted">Pick something you love and it will wait for you here.</p>
            <button className="ck-btn" onClick={() => navigate("/")}><ShoppingBag size={15} /> Start shopping</button>
          </div>
        ) : (
          <>
            <div className="ck-card">
              <div className="ck-card-head">
                <span className="ck-step y">1</span>
                <span className="ck-card-title">Your pretty bag</span>
                <button type="button" className="ck-clear" onClick={clearAll}><Trash2 size={13} /> Clear</button>
              </div>
              {lines.map((l) => (
                <div key={l.key} className="ck-line">
                  <div
                    className="ck-thumb"
                    onMouseEnter={(e) => { const r = e.currentTarget.getBoundingClientRect(); setHov({ productId: l.productId, x: r.right + 14, y: r.top }); }}
                    onMouseLeave={() => setHov(null)}
                  >
                    {l.photo ? <img src={l.photo} alt={l.name} /> : <PackageOpen size={22} strokeWidth={1.2} />}
                  </div>
                  <div className="ck-grow">
                    <b className="ck-name">{l.name}</b>
                    {(l.color || l.size) && (
                      <div className="ck-opts">
                        {l.color && <span className="ck-opt">{l.color}</span>}
                        {l.size && <span className="ck-opt">{l.size}</span>}
                      </div>
                    )}
                    <div className="ck-each">{money(l.price)} each</div>
                  </div>
                  <div className="ck-right">
                    <span className="ck-lt">{money(l.price * l.qty)}</span>
                    <div className="ck-qty">
                      <button aria-label="Remove one" disabled={l.qty <= 1} onClick={() => bump(l.key, -1)}><Minus size={14} /></button>
                      <b>{l.qty}</b>
                      <button aria-label="Add one" disabled={l.qty >= maxFor(l)} onClick={() => bump(l.key, 1)}><Plus size={14} /></button>
                    </div>
                    {maxFor(l) !== Infinity && l.qty >= maxFor(l) && <span className="ck-cap">Max {maxFor(l)}</span>}
                    <button className="ck-x" aria-label={`Remove ${l.name}`} onClick={() => drop(l.key)}><Trash2 size={15} /></button>
                  </div>
                </div>
              ))}
            </div>

            <div className="ck-card">
              <div className="ck-card-head">
                <span className="ck-step l">2</span>
                <span className="ck-card-title">Who is it for?</span>
              </div>
              <button type="button" className={`ck-gift${gifting ? " on" : ""}`} aria-pressed={gifting} onClick={() => setGifting((v) => !v)}>
                <span className="ck-orb"><Gift size={20} strokeWidth={2} /></span>
                <span className="ck-gtext">
                  <b>Buy for someone else</b>
                  <span className="sub">{gifting ? "We will send it to them with love" : "Sending it as a gift? Tell us where"}</span>
                </span>
                <span className="ck-knob" />
              </button>

              {gifting && (
                <div className="ck-form">
                  {field("firstName", "First name", { req: true })}
                  {field("lastName", "Last name")}
                  {field("email", "Their email", { req: true, full: true, type: "email", ph: "them@email.com" })}
                  {field("phone", "Their phone", { full: true, type: "tel", ph: "+372 5000 0000" })}
                  {field("address", "Address", { req: true, full: true, ph: "Street, apartment, building" })}
                  {field("city", "City", { req: true })}
                  {field("postalCode", "Postal code")}
                  {field("state", "State / Province")}
                  {field("country", "Country", { req: true })}
                </div>
              )}
            </div>

            <div className="ck-card">
              <div className="ck-card-head">
                <span className="ck-step">3</span>
                <span className="ck-card-title">Time to pay</span>
              </div>
              <div className="ck-row"><span className="ck-muted">{count} {count === 1 ? "piece" : "pieces"}</span><span>{money(total)}</span></div>
              <div className="ck-row"><span className="ck-muted">Shipping</span><span>Set at payment</span></div>
              <div className="ck-total"><small>Total</small><b>{money(total)}</b></div>
              {error && <p className="ck-error">{error}</p>}
              <button className="ck-btn block" onClick={pay} disabled={busy}>
                {busy ? <><Loader2 size={16} className="ck-spin" /> Opening secure checkout</> : <><Lock size={16} /> Pay securely</>}
              </button>
              <p className="ck-muted ck-small ck-trust"><Heart size={13} fill={PINK} color={INK} /> Cards, Apple Pay and Google Pay. Prices are re-checked on our server.</p>
            </div>
          </>
        )}

        {gone.length > 0 && (
          <div className="ck-card">
            <div className="ck-gonehead">
              <span className="ck-step">!</span>
              <span className="ck-card-title">No longer available</span>
              <button type="button" className="ck-clear" onClick={() => setGone([])}>Dismiss</button>
            </div>
            <div className="ck-gonegrid">
              {gone.map((g) => (
                <div key={g.id} className="ck-gcard">
                  <div className="ck-gimg">
                    {g.photo ? <img src={g.photo} alt={g.name} /> : <PackageOpen size={28} strokeWidth={1.2} />}
                    <span className="ck-gtag">{g.reason === "reserved" ? "In another bag" : g.left > 0 ? "Fewer left" : "Gone"}</span>
                  </div>
                  <div className="ck-ginfo">
                    <b>{g.name}</b>
                    {(g.color || g.size) && <span>{[g.color, g.size].filter(Boolean).join(" · ")}</span>}
                    <em>
                      {g.reason === "reserved"
                        ? g.left > 0 ? `Only ${g.left} free, the rest is in another buyer's checkout. Try again in a few minutes.` : "Held in another buyer's checkout. Try again in a few minutes."
                        : g.left > 0 ? `You wanted ${g.wanted}, only ${g.left} left. Bag updated.` : g.reason === "out-of-stock" ? "Sold out. Removed from your bag." : "Removed from your bag."}
                    </em>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {hov && (() => {
        const group = lines.filter((x) => x.productId === hov.productId);
        if (!group.length) return null;
        const p = productOf(hov.productId);
        const hexOf = (c?: string): string | null => (p?.variants || []).find((v: any) => v.color === c)?.hex || null;
        const pcs = group.reduce((s, x) => s + x.qty, 0);
        const sum = group.reduce((s, x) => s + x.price * x.qty, 0);
        const left = Math.min(hov.x, window.innerWidth - 324);
        const top = Math.max(12, Math.min(hov.y, window.innerHeight - (104 + group.length * 72) - 12));
        return (
          <div className="ck-hov" style={{ left, top }}>
            <h4>{group[0].name}</h4>
            {group.map((x) => (
              <div key={x.key} className="ck-hrow">
                <div className="ck-hph">{x.photo ? <img src={x.photo} alt="" /> : <PackageOpen size={16} strokeWidth={1.2} color="#6B6B6B" />}</div>
                <div className="ck-grow">
                  <div className="ck-hcol">
                    {hexOf(x.color) && <i className="ck-hdot" style={{ background: hexOf(x.color) as string }} />}
                    {x.color || "Default"}{x.size ? ` · ${x.size}` : ""}
                  </div>
                  <div className="ck-small ck-muted">{x.qty} × {money(x.price)}</div>
                </div>
                <b>{money(x.price * x.qty)}</b>
              </div>
            ))}
            <div className="ck-hfoot"><span>{pcs} {pcs === 1 ? "piece" : "pieces"}</span><b>{money(sum)}</b></div>
          </div>
        );
      })()}
      </div>
      <Footer />
    </div>
  );
}